import { Box, Container, useColorModeValue } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

export interface WarningProps {
  children?: ReactNode;
  bgColor?: string;
  color?: string;
}

export const Warning: FC<WarningProps> = ({ children, bgColor = 'orange.100', color = 'default' }) => {
  return (
    <Box bgColor={bgColor} color={color} boxShadow={useColorModeValue('lg', 'lg-dark')} borderRadius="lg" position="relative">
      <Container py={{ base: '4', md: '3.5' }} maxW={'unset'}>
        {children}
      </Container>
    </Box>
  );
};
